import Meetings from "./features/meeting/Meetings";
import Orders from "./features/order/Orders";
import Phones from "./features/Phone/Phone";
import Diagrams from "./components/dashboard/Diagrams/Diagrams";
import Report from "./features/reports/Report";

const AppRoutes = [
  {
    index: 'orders',
    element: <Orders />
  },
  {
    index: 'phone',
    element: <Phones />
  },
  {
    index: 'meetings',
    element: <Meetings />
  },
  {
    index: 'diagrams',
    element: <Diagrams />
  },
  {
    index: 'reports',
    element: <Report />
  },
];

export default AppRoutes;
